import { createBrowserRouter, replace } from 'react-router';

import { RootLayout } from '@crm/app/layout';
import { ROUTES } from '@crm/shared/routes';

import { RouterHydrateFallback } from './RouterHydrateFallback';

export const createCrmRouter = (basename = '/crm') =>
    createBrowserRouter(
        [
            {
                path: ROUTES.HOME,
                Component: RootLayout,
                HydrateFallback: RouterHydrateFallback,
                children: [
                    {
                        index: true,
                        loader: () => replace(ROUTES.DEALS),
                    },
                    {
                        path: ROUTES.TASKS,
                        lazy: async () => {
                            const { TasksPage } = await import('@crm/pages/tasks');

                            return { Component: TasksPage };
                        },
                    },
                    {
                        path: ROUTES.DEALS,
                        lazy: async () => {
                            const { DealsPage } = await import('@crm/pages/deals');

                            return { Component: DealsPage };
                        },
                    },
                    {
                        path: ROUTES.POSTPONED_DEALS,
                        lazy: async () => {
                            const { PostponedDealsPage } = await import(
                                '@crm/pages/deals-postponed'
                            );
                            return { Component: PostponedDealsPage };
                        },
                    },
                    {
                        path: ROUTES.LOST_DEALS,
                        lazy: async () => {
                            const { DealsLostPage } = await import('@crm/pages/deals-lost');
                            return { Component: DealsLostPage };
                        },
                    },
                    {
                        path: ROUTES.IN_WORK_OR_FINISHED_DEALS,
                        lazy: async () => {
                            const { DealsInWorkOrFinishedPage } = await import(
                                '@crm/pages/deals-in-work-or-finished'
                            );
                            return { Component: DealsInWorkOrFinishedPage };
                        },
                    },
                    {
                        path: ROUTES.DEAL,
                        lazy: async () => {
                            const { DealDetailsPage } = await import('@crm/pages/deal-details');
                            return { Component: DealDetailsPage };
                        },
                    },
                    {
                        path: ROUTES.LEADS,
                        lazy: async () => {
                            const { LeadsPage } = await import('@crm/pages/leads');

                            return { Component: LeadsPage };
                        },
                    },
                    {
                        path: ROUTES.DASHBOARD,
                        lazy: async () => {
                            const { DashboardPage } = await import('@crm/pages/dashboard');

                            return { Component: DashboardPage };
                        },
                    },
                    {
                        path: ROUTES.PROFILE,
                        lazy: async () => {
                            const { ProfilePage } = await import('@crm/pages/profile');

                            return { Component: ProfilePage };
                        },
                    },
                    {
                        path: ROUTES.ORDERS,
                        lazy: async () => {
                            const { OrdersPage } = await import('@crm/pages/orders');

                            return { Component: OrdersPage };
                        },
                    },
                ],
            },
        ],
        {
            basename,
        }
    );
